import template   from './my-updates-tab.html'
import controller from './my-updates-tab.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-updates-tab/my-updates-tab.component.js